import { FC } from 'react';
import { Modal, Table } from 'react-bootstrap';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}
const formatDateForInput = (timestamp: number) => {
    if (!timestamp || isNaN(timestamp)) return '';
    try {
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return '';

        const month = date.getMonth() + 1; // No padding with zeros
        const day = date.getDate(); // No padding with zeros
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    } catch {
        return '';
    }
};

export const DeliveryOrderAddress: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}>
                        X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        {/* <h1 className="mb-3">GRN Information</h1> */}
                    </div>

                    {/* Table 1: Supplied WT, Received WT, Gain/Loss */}
                    <div className="mb-10">
                        {/* <h3 className="mb-5">Weight </h3> */}
                        <Table bordered hover>
                            <thead style={{ backgroundColor: '#BFD7ED' }}>
                                <tr>
                                    <th>Delivery Address</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{user?.deliveryAddress || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>


                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};